import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Button } from '@ovComponents/2-component/button/button';
import type { FC } from 'react';
import {
  formatFooterRowCount,
  formatFooterThreshold,
  WATCH_LIST_COPY,
} from './watchListCopy';

export type WatchListFooterProps = {
  /** Number of rows currently shown in the table. */
  shown: number;
  /** Band-consumed threshold percentage, e.g. 75. */
  approachThreshold: number;
  /**
   * When provided, a "Configure" link is rendered after the threshold copy.
   * When undefined the link is hidden — avoids shipping a dead control until
   * the destination is wired. Mirrors the `onViewAllClick` pattern.
   */
  onConfigureClick?: () => void;
};

export const WatchListFooter: FC<WatchListFooterProps> = ({
  shown,
  approachThreshold,
  onConfigureClick,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        mb: 2,
        px: 1,
      }}
    >
      <Typography variant='bodySmall' colorVariant='variant'>
        {formatFooterRowCount(shown)}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant='bodySmall' colorVariant='variant'>
          {formatFooterThreshold(approachThreshold)}
        </Typography>

        {onConfigureClick && (
          <Button
            variant='text'
            size='sm'
            label={WATCH_LIST_COPY.footer.configure}
            onClick={onConfigureClick}
          />
        )}
      </Box>
    </Box>
  );
};
